<section class="stock-take-retry-loading-modal" aria-live="polite" aria-busy="true">
  <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
  <h3 class="stock-take-retry-loading-modal-message">{{ message }}</h3>
</section>
